var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<dl class=\"dl-horizontal left\"> <registry-annotations annotations=\"imagestream.metadata.annotations\"></registry-annotations> </dl>";
ngModule.run(["$templateCache",function(c){c.put("registry-image-widgets/views/imagestream-meta.html",v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./views/imagestream-meta.html
// module id = 16
// module chunks = 0